var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoValveOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 276,
    height: 51,
    viewBox: "0 0 276 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Valve_OFF",
    "data-name": "Valve OFF",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9825",
    "data-name": "Group 9825",
    transform: "translate(34.001 15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3897",
    "data-name": "Path 3897",
    d: "M265.168,43.22H36.59a2.62,2.62,0,0,1,0-5.24H265.168a5.458,5.458,0,0,0,5.65-5.23V17.62a2.59,2.59,0,1,1,5.18,0V32.75A10.657,10.657,0,0,1,265.168,43.22Z",
    transform: "translate(-34 -15)",
    fill: "#6a7084"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9828",
    "data-name": "Group 9828",
    transform: "translate(-0.001 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9826",
    "data-name": "Group 9826"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3898",
    "data-name": "Path 3898",
    d: "M40.66,12.07l-2.19,1.14a19.712,19.712,0,0,1,1.14,2.66l2.34-.79A21.3,21.3,0,0,0,40.66,12.07Z",
    transform: "translate(0.002 0)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3899",
    "data-name": "Path 3899",
    d: "M42.5,16.96l-2.4.57a16.567,16.567,0,0,1,.44,2.84L43,20.19A21.227,21.227,0,0,0,42.5,16.96Z",
    transform: "translate(0.002 0)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3900",
    "data-name": "Path 3900",
    d: "M37.81,7.75,35.9,9.31a18.537,18.537,0,0,1,1.66,2.36l2.13-1.25A20.407,20.407,0,0,0,37.81,7.75Z",
    transform: "translate(0.002 0)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3901",
    "data-name": "Path 3901",
    d: "M34.02,4.16,32.55,6.14a17.89,17.89,0,0,1,2.19,1.89L36.5,6.3A22.931,22.931,0,0,0,34.02,4.16Z",
    transform: "translate(0.002 0)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3902",
    "data-name": "Path 3902",
    d: "M28.52,3.88a18.878,18.878,0,0,1,2.58,1.3l1.28-2.11A20.994,20.994,0,0,0,29.46,1.6Z",
    transform: "translate(0.002 0)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3903",
    "data-name": "Path 3903",
    d: "M24.06,2.66a18.648,18.648,0,0,1,2.83.64L27.62.95A22.245,22.245,0,0,0,24.43.23Z",
    transform: "translate(0.002 0)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3904",
    "data-name": "Path 3904",
    d: "M22.33,2.49,22.46.03a20.988,20.988,0,0,0-3.27.08l.25,2.45A18.576,18.576,0,0,1,22.33,2.49Z",
    transform: "translate(0.001 0)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3905",
    "data-name": "Path 3905",
    d: "M15.64,3.34a21.119,21.119,0,0,1,2.08-.53L17.24.4A20.575,20.575,0,0,0,14.9,1l-.81.27.84,2.32C15.16,3.5,15.4,3.42,15.64,3.34Z",
    transform: "translate(0.001 0)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3906",
    "data-name": "Path 3906",
    d: "M13.32,4.25,12.27,2.02A20.458,20.458,0,0,0,9.42,3.63L10.8,5.67A17.87,17.87,0,0,1,13.32,4.25Z",
    transform: "translate(0.001 0)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3907",
    "data-name": "Path 3907",
    d: "M9.41,6.7,7.84,4.79A22,22,0,0,0,5.47,7.05L7.31,8.69A18.848,18.848,0,0,1,9.41,6.7Z",
    transform: "translate(0.001 0)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3908",
    "data-name": "Path 3908",
    d: "M6.21,10.03,4.23,8.56a21.422,21.422,0,0,0-1.75,2.76l2.18,1.15A20.544,20.544,0,0,1,6.21,10.03Z",
    transform: "translate(0.001 0)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3909",
    "data-name": "Path 3909",
    d: "M3.92,14.04l-2.28-.95a21.253,21.253,0,0,0-1.03,3.1l2.4.59A20.458,20.458,0,0,1,3.92,14.04Z",
    transform: "translate(0.001 0)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3910",
    "data-name": "Path 3910",
    d: "M2.68,18.48.24,18.11A19.673,19.673,0,0,0,0,21.36l2.47-.01A19.591,19.591,0,0,1,2.68,18.48Z",
    transform: "translate(0.001 0)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3911",
    "data-name": "Path 3911",
    d: "M20.861,38.62l1.6,1.51A18.868,18.868,0,0,1,2.69,23.47l-2.46.27A21.35,21.35,0,0,0,22.7,42.59l-1.64,1.72,1.8,1.69,4.45-4.68-4.76-4.49Z",
    transform: "translate(0.001 0)",
    fill: "#00b7ff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9827",
    "data-name": "Group 9827",
    transform: "translate(9.811 13.33)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3912",
    "data-name": "Path 3912",
    d: "M9.81,13.77a26.177,26.177,0,0,1,4.07-.31c2.12,0,3.57.35,4.55,1.18a3.715,3.715,0,0,1,1.27,2.94,3.932,3.932,0,0,1-2.67,3.69v.07a3.741,3.741,0,0,1,2.06,2.83,29.017,29.017,0,0,0,1.16,4.1H17.47a21.082,21.082,0,0,1-.99-3.47c-.42-1.92-1.12-2.53-2.65-2.57H12.47v6.04H9.81Zm2.67,6.5h1.6c1.82,0,2.95-.96,2.95-2.42,0-1.61-1.14-2.36-2.89-2.36a8.149,8.149,0,0,0-1.66.13v4.65Z",
    transform: "translate(-9.81 -13.33)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3913",
    "data-name": "Path 3913",
    d: "M35.35,20.77c0,4.93-3,7.74-7.07,7.74-4.16,0-6.79-3.16-6.79-7.48,0-4.52,2.85-7.7,7-7.7C32.82,13.34,35.35,16.58,35.35,20.77Zm-11,.22c0,2.99,1.51,5.36,4.09,5.36,2.6,0,4.07-2.4,4.07-5.47,0-2.77-1.38-5.39-4.07-5.39C25.77,15.49,24.35,17.96,24.35,20.99Z",
    transform: "translate(-9.81 -13.33)",
    fill: "#00b7ff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_3914",
    "data-name": "Path 3914",
    d: "M63.261,37.99H36.59a2.62,2.62,0,0,0,0,5.24H63.251V37.99Z",
    transform: "translate(0.001)",
    fill: "#00b7ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9829",
    "data-name": "Group 9829",
    transform: "translate(57.502 31.44)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3915",
    "data-name": "Path 3915",
    d: "M68.53,42.26,57.5,49.77V31.44l11.03,7.51,11.02-7.51V49.77Z",
    transform: "translate(-57.5 -31.44)",
    fill: "#2f323a"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9830",
    "data-name": "Group 9830",
    transform: "translate(56.862 30.21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3916",
    "data-name": "Path 3916",
    d: "M78.9,32.67V48.54l-5.82-3.97-4.55-3.1-4.55,3.1-5.82,3.97V32.66l5.82,3.97,4.55,3.1,4.55-3.1,5.82-3.96m1.3-2.46-2.02,1.38-5.82,3.97-3.83,2.61L64.7,35.56l-5.82-3.97-2.02-1.38V51l2.02-1.38,5.82-3.97,3.83-2.61,3.83,2.61,5.82,3.97L80.2,51V30.21Z",
    transform: "translate(-56.86 -30.21)",
    fill: "#6a7084"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoValveOff);
export default __webpack_public_path__ + "static/media/ro_valve_off.25b38b10ebed4c175ee58d21d73a2358.svg";
export { ForwardRef as ReactComponent };